/* eslint-disable max-lines */
import {resources, scopes} from '../../permissions/dictionary';
import {paths} from '../../dictionaries/urls';
import {filterByPermissions} from './helpers';

const vehicleOutcomeReport = [
  {
    'name': 'Reporte de Inventario Flotante',
    'path': paths.FloatingInventoryReport,
    'resource': resources.FloatingInventoryReport,
    'scopes': [scopes.See],
    'icon': 'certificate',
  },
  {
    'name': 'Auditoría Vehículos',
    'path': paths.VehAudi,
    'resource': resources.VehAudi,
    'scopes': [scopes.See],
    'icon': 'support',
  },
  {
    'name': 'Eficiencia Vehículos',
    'path': paths.VehiclesEfficiency,
    'resource': resources.VehiclesEfficiencyKpi,
    'scopes': [scopes.See],
    'icon': 'vehiclesEfficiency',
  },
  {
    'name': 'Historial Vehículos',
    'path': paths.VehiclesHistory,
    'resource': resources.vehicleHistory,
    'scopes': [scopes.See],
    'icon': 'vehiclesHistory',
  },
  {
    'name': 'KPI Stock Vehículos',
    'path': paths.VehiclesKpi,
    'resource': resources.VehiclesKpi,
    'scopes': [scopes.See],
    'icon': 'carStock',
  },
  {
    'name': 'Resumen Ventas y Stock Diario',
    'path': paths.DailyVehiclesSalesAndStockSummary,
    'resource': resources.DailyVehiclesSalesAndStockSummary,
    'scopes': [scopes.See],
    'icon': 'vehicleSalesAndStockSummary',
  },
  {
    'name': 'Ventas y Stock Diario',
    'path': paths.DailyVehiclesSalesAndStockReport,
    'resource': resources.DailyVehiclesSalesAndStockReport,
    'scopes': [scopes.See],
    'icon': 'vehicleSaleReport',
  },
  {
    'name': 'Ventas y Stock WH',
    'path': paths.DailyVehiclesSalesAndStockWholesale,
    'resource': resources.DailyVehiclesSalesAndStockWholesales,
    'scopes': [scopes.See],
    'icon': 'vehicleSaleReport',
  },
];
const vehiclesIncomeMaintenance = [
  {
    'name': 'Gestión de colores',
    'path': paths.ManageColors,
    'resource': resources.ManageColors,
    'scopes': [scopes.See],
    'icon': 'manageColors',
  },
  {
    'name': 'Gestión de segmentos',
    'path': paths.VehiclesModels,
    'resource': resources.VehiclesModels,
    'scopes': [scopes.See],
    'icon': 'dateManagement',
  },
  {
    'name': 'Gestión de semanas',
    'path': paths.ManageDatesBudget,
    'resource': resources.ManageDatesBudget,
    'scopes': [scopes.See],
    'icon': 'dateManagement',
  },
  {
    'name': 'Mantenimiento Vehículos',
    'path': paths.MasterVehicleList,
    'resource': resources.MasterVehicleList,
    'scopes': [scopes.See],
    'icon': 'vehicleMaster',
  },
  {
    'name': 'Mantenimiento de Agencias',
    'path': paths.MaintainSaleForecast,
    'resource': resources.MaintainSaleForecast,
    'scopes': [scopes.See, scopes.Create, scopes.Edit],
    'icon': 'certificate',
  },
  {
    'name': 'Proyección ventas',
    'path': paths.VehicleSaleForecastNormals,
    'resource': resources.VehicleSaleForecast,
    'scopes': [scopes.Create],
    'icon': 'vehicleSaleForecast',
  },
  {
    'name': 'Proyección ventas exonerados',
    'path': paths.VehicleSaleForecastExonerated,
    'resource': resources.VehicleSaleForecastExonerated,
    'scopes': [scopes.Create],
    'icon': 'vehicleSaleForecast',
  },
  {
    'name': 'Segmentos katashiki',
    'path': paths.VehiclesMaintenance,
    'resource': resources.VehiclesMaintenance,
    'scopes': [scopes.See],
    'icon': 'vehiclesMaintenance',
  },
  {
    'name': 'WholeSale Planeado',
    'path': paths.WholeSalePlanned,
    'resource': resources.WholeSalePlanned,
    'scopes': [scopes.See, scopes.Create, scopes.Edit],
    'icon': 'certificate',
  },
  {
    'name': 'Administración de Clientes Exonerados',
    'path': paths.ClientManagement,
    'resource': resources.ClientManagement,
    'scopes': [scopes.See, scopes.Create, scopes.Edit],
    'icon': 'partsMaster',
  },
  {
    'name': 'Administración de Porcentajes de Exoneración',
    'path': paths.ExemptionPercentagesManagement,
    'resource': resources.ExemptionPercentagesManagement,
    'scopes': [scopes.See, scopes.Create, scopes.Edit],
    'icon': 'vehicleSaleForecast',
  },
  {
    'name': 'Administración de Asesores',
    'path': paths.AdvisorManagement,
    'resource': resources.AdvisorManagement,
    'scopes': [scopes.See, scopes.Create, scopes.Edit],
    'icon': 'partsMaster',
  },
];

const vehiclesIncomeMaintenanceOrder = [
  {
    'name': 'Pedidos',
    'path': paths.ManageOrders,
    'resource': resources.ManageOrdersCreate,
    'scopes': [scopes.See, scopes.Create, scopes.Edit],
    'icon': 'dealerOrdersTracking',
  },
  {
    'name': 'Inventario',
    'path': paths.VehiclesInventory,
    'resource': resources.VehiclesInventory,
    'scopes': [scopes.See, scopes.Create, scopes.Edit],
    'icon': 'combosReport',
  },
  {
    'name': 'Administración de Inventario Flotante',
    'path': paths.FloatingInventorySummary,
    'resource': resources.FloatingInventory,
    'scopes': [scopes.See, scopes.Create, scopes.Edit],
    'icon': 'dealerSpecialOrders',
  },
  {
    'name': 'Auditoría de Inventario Flotante',
    'path': paths.FloatingInventoryAudit,
    'resource': resources.FloatingInventoryAudit,
    'scopes': [scopes.See, scopes.Create, scopes.Edit],
    'icon': 'certificate',
  },
];

const vehicleRequests = [
  {
    'name': 'Seguimiento de cliente',
    'path': paths.CustomerTracking,
    'resource': resources.CustomerTracking,
    'scopes': [scopes.See],
    'icon': 'vehicleMaster',
  },
];

const vehicleSaleReport = [
  {
    'name': 'Reporte de ventas - Vehículos',
    'path': paths.VehiclesSaleReport,
    'resource': resources.VehiclesSaleReport,
    'scopes': [scopes.See],
    'icon': 'vehicleSaleReport',
  },
];

const vehicleCertification = [
  {
    'name': 'CPO',
    'path': paths.VehiclesCertification,
    'resource': resources.VehiclesCertification,
    'scopes': [scopes.See],
    'icon': 'certificate',
  },
  {
    'name': 'Listar Solicitudes CPO',
    'path': paths.ListVehiclesCertification,
    'resource': resources.ListVehiclesCertification,
    'scopes': [scopes.See],
    'icon': 'certificate',
  },
  {
    'name': 'Registro de Autos Vendidos CPO',
    'path': paths.VehiclesCertificationSale,
    'resource': resources.VehiclesCertificationSale,
    'scopes': [scopes.See],
    'icon': 'certificate',
  },
];

const anticipatedInvoice = [
  {
    'name': 'Selección de Vehículos',
    'path': paths.AnticipatedInvoiceVehiclesSelection,
    'resource': resources.AnticipatedInvoiceVehicleSelection,
    'scopes': [scopes.See, scopes.Edit],
    'icon': 'vehicleMaster',
  },
  {
    'name': 'Validación de Vehículos',
    'path': paths.AnticipatedInvoiceVehiclesValidation,
    'resource': resources.AnticipatedInvoiceVehicleValidation,
    'scopes': [scopes.See, scopes.Edit],
    'icon': 'vehicleMaster',
  },
];

const dispatchOrders = [
  {
    'name': 'Aprobación de órdenes',
    'path': paths.DispatchOrdersApprovals,
    'resource': resources.DispatchOrdersApproval,
    'scopes': [scopes.Approve],
    'icon': 'order',
  },
  {
    'name': 'Listado de órdenes',
    'path': paths.DispatchOrdersList,
    'resource': resources.DispatchOrders,
    'scopes': [scopes.See, scopes.Create, scopes.Edit],
    'icon': 'order',
  },
];

const vehiclesPriorization = [
  {
    'name': 'Producción de vehículos',
    'path': paths.VehiclesPriorizationDates,
    'resource': resources.VehiclesPriorizationDates,
    'scopes': [scopes.See, scopes.Create, scopes.Edit],
    'icon': 'order',
  },
  {
    'name': 'Administración de Cupo Diario',
    'path': paths.VehiclesPriorizationDailyQuota,
    'resource': resources.VehiclesPriorizationDailyQuota,
    'scopes': [scopes.See, scopes.Edit],
    'icon': 'manageColors',
  },
];

const getVehiclesIncomeOptions = (permissions) => {
  const options = [
    {
      'name': 'Mantenimiento',
      'options': filterByPermissions(permissions, vehiclesIncomeMaintenance),
    },
    {
      'name': 'Mantenimiento Pedidos',
      'options': filterByPermissions(permissions, vehiclesIncomeMaintenanceOrder),
    },
  ];

  return options.filter((item) => item.options.length);
};

const getVehiclesProcessOptions = (permissions) => {
  const options = [
    {
      'name': 'Solicitud',
      'options': filterByPermissions(permissions, vehicleCertification),
    },
    {
      'name': 'Facturación anticipada',
      'options': filterByPermissions(permissions, anticipatedInvoice),
    },
    {
      'name': 'Órdenes de despacho',
      'options': filterByPermissions(permissions, dispatchOrders),
    },
    {
      'name': 'Priorización',
      'options': filterByPermissions(permissions, vehiclesPriorization),
    },
  ];

  return options.filter((item) => item.options.length);
};

const getVehiclesOutcomeOptions = (permissions) => {
  const options = [
    {
      'name': 'Reportes',
      'options': filterByPermissions(permissions, vehicleOutcomeReport),
    },
    {
      'name': 'Consultas',
      'options': filterByPermissions(permissions, vehicleRequests),
    },
  ];

  return options.filter((item) => item.options.length);
};

export const getVehiclesOptions = (permissions) => {
  const options = [{
    'name': 'Entrada',
    'options': getVehiclesIncomeOptions(permissions),
  },
  {
    'name': 'Proceso',
    'options': getVehiclesProcessOptions(permissions),
  },
  {
    'name': 'Salida',
    'options': getVehiclesOutcomeOptions(permissions),
  }];
  
  return options.filter((item) => item.options.length);
};


export const vehiclesOptions = [
  ...vehicleOutcomeReport,
  ...vehiclesIncomeMaintenance,
  ...vehicleSaleReport,
  ...vehicleCertification,
  ...anticipatedInvoice,
  ...dispatchOrders,
  ...vehiclesIncomeMaintenanceOrder,
  ...vehicleRequests,
  ...vehiclesPriorization,
];
